import { TrashSimple } from "@phosphor-icons/react"
import { useChMedicationDetailByIdQuery } from "@/modules/patients/detail/medication/ch/services/useChMedicationDetailByIdQuery"

interface DeleteMedicationButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  id: string
}

const DeleteMedicationButton = ({ id, ...props }: DeleteMedicationButtonProps) => {
  const medication = useChMedicationDetailByIdQuery({ id, fetchPolicy: "network-only" })

  return (
    medication?.result?.canDelete && (
      <button data-testid="delete-button" {...props}>
        <TrashSimple className="text-on-surface-subdued" />
      </button>
    )
  )
}

export { DeleteMedicationButton }
